export const overdraftDetail = {
    overdraftCollapsible: {
        showOverDraftName: true,
        showContractNumber: true,
        showReviewDate: true,
        showApprovedLimit: true,
        showLimitValidity: true,
        showNextInstallmentDate: true,
    },
};
